// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"AlarmSettingScreen_buttonsContainer__k-Gc+","button":"AlarmSettingScreen_button__pOJ5j"};